import axios from 'axios';

export const loadAssignmentUsers = async (signal) => {
  const users = new Map();
  let skip = 0;
  while (true) {
    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users`, {
      withCredentials: true, signal, params: { skip, limit: 200 },
    });
    const items = Array.isArray(data) ? data : data.items || [];
    items.forEach(user => users.set(user.id, user));
    skip += items.length;
    if (Array.isArray(data) || !items.length || skip >= data.total) break;
  }
  return [...users.values()].sort((a, b) => (a.name || a.email || '').localeCompare(b.name || b.email || '', 'es'));
};